import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Stack, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import styledComponent from 'styled-components';

export const MiscUtilityDesc = ({ isModEdit }) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  return (
    <Grid>
      <Grid item xs={12}>
        <Controller
          name="utilityNotes"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <Stack>
              <TextField
                value={getValues('utilityNotes')}
                maxRows={5}
                InputLabelProps={{
                  shrink: getValues('utilityNotes') ?? false,
                }}
                inputProps={{
                  maxLength: 1000,
                }}
                variant="filled"
                multiline={true}
                label={t(`placement.placementMods.miscUtilityDesc`)}
                InputProps={{
                  readOnly: !isModEdit,
                  style: {
                    pointerEvents: 'auto',
                    overflowY: 'auto'
                  },
                  sx: { fontSize: '14px' },
                }}
                {...rest}
              />
              <DescriptionCountStyle>{`${
                getValues('utilityNotes')?.length ? getValues('utilityNotes')?.length : 0
              }/1,000`}</DescriptionCountStyle>
            </Stack>
          )}
        />
      </Grid>
    </Grid>
  );
};
const DescriptionCountStyle = styledComponent.div`
display: flex;
justify-content: flex-end;
font-size: 10px;
`;
